<template>
    <div>
        <el-card shadow="hover">
            <div slot="header" class="px-2">
                <h5 class="text-center m-0 px-4">{{ title }}</h5>
            </div>
            <LineChart v-loading.body="loading.chart" :data="chartdata" :width="500" :height="180" style="margin-top:20px;"/>
            <Loader v-if="loading.chart" />
        </el-card>
    </div>  
</template>

<script>
import Treasury from '@/components/page/Treasury.js'
//import PieChart from '@/components/chart/Pie.js' //
import PieChart from '@/components/chart/Doughnut.js'
import LineChart from '@/components/chart/LineChart.js'
import { Rainbow, Rainbow3, Penanggalan, AppColors, Config, AxiosWithJar } from '@/utility.js'
import Loader from '@/components/loader/Loader2.vue'

export default {
    extends: Treasury,
    components:{ 
        //PieChart,
        LineChart,
        Loader,
     },
    props: {
        id: {
            type: String,
            default: '',
            //required: false,
        }
    },
    setup() {
        
    },
    mounted() {
        //this.setCashNonCashData()
        this.getDailyTransaction()
    },
    data() {
        return {
            title: 'Daily Transactions This Month',
            chartdata: [],
            countdata: 0,
 
            loading : {
                table: true,
                chart: true,
            }
        }
    }, 
    methods: {
        async getDailyTransaction() {
			this.urlRequestParams=Config().apiURL
            this.urlRequestParams+='/v1/brightpaymentpoint/charttransactionthismonth?' //chartmonthcomparison
            //this.urlRequestParams+='&count=8' 
            //this.urlRequestParams+='&sltype='+this.sltype
            
			this.loading.chart = true
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
                    //this.loading.isSuccess = true
					//this.reportdata = response.data;
                    this.dailytransaction = response.data.data;
                    let legend = 'Label';
                    let valuecol = 'Value';
                    let label = 'Day';
                    let prefix = '';
                    let colors = AppColors; //['#BCBBD6','#583EC3'];
                    this.chartdata = this.processBarChart(response.data.data, legend, prefix, valuecol, false, label, "", 1, 2, colors, false, false, false)
                    
				})
				.catch(error => {
					//console.log(error)
                    this.loading.isSuccess = false
                    this.reportdata = []
                    let errMsg = error
                    this.$alert(errMsg, 'Error', {
                        confirmButtonText: 'Close',
                        callback: action => {
                            this.$message({
                            type: 'danger',
                            message: `Please try again.`
                            });
                        }
                    });
				})
				.finally(() => {
					this.loading.chart = false;
				})
		},
    }
}
</script>

<style>
.el-card__header {
    padding: 12px 10px;
}
</style>